import { render } from "./Vehicle.vue?vue&type=template&id=746177de"
import script from "./Vehicle.vue?vue&type=script&lang=js"
export * from "./Vehicle.vue?vue&type=script&lang=js"
script.render = render

export default script